<template>
  <div style="align-self: self-end;">
    <div>
      <v-card-actions class="outer-div">
        <div>
          <v-btn @click="toggleLikeChapter" outlined class="btn-heart" dark>
            <v-badge :content="chapter.likes_count" :value="chapter.likes_count > 0" color="red" overlap offset-x="10" offset-y="10">
              <v-icon color="white">
                {{ chapter.is_like ? 'mdi-heart' : 'mdi-heart-outline' }}
              </v-icon>
            </v-badge>
          </v-btn>
        </div>
        <div>
          <v-btn @click="shareOnWhatApp" outlined class="btn-heart" dark>
            <v-icon color="white">mdi-share-variant</v-icon>
          </v-btn>
        </div>
        <div>
          <v-btn @click="backChapter" outlined class="btn-heart" dark :disabled="!previous_title" >
            <v-icon color="white">mdi-chevron-left</v-icon>
          </v-btn>
        </div>
        <div>
          <v-btn @click="nextChapter" outlined class="btn-heart" dark :disabled="!next_chapter">
            <v-icon color="white">mdi-chevron-right</v-icon>
          </v-btn>
        </div>
        <div>
          <v-btn @click="openMenuModal" outlined class="btn-heart" dark>
            <v-icon color="white">mdi-menu</v-icon>
          </v-btn>
        </div>
      </v-card-actions>
    </div>
    <v-dialog v-model="menuModalOpen" max-width="600" dark>
      <v-card>
        <v-card-title>Menu</v-card-title>
        <v-col v-for="(chapter, index) in chapters" :key="index" cols="12" md="12" lg="8">
          <v-card class="d-flex flex-row align-center mb-4 card-obra" @click="goToReadingPage(chapter.id)" hover>
            <v-img :src="chapter.title_thumb" alt="Capa do capítulo" class="chapter-image" height="130"
              width="90"></v-img>
            <v-card-text>
              <div class="font-weight-bold chapter-title">{{ chapter.name }}</div>
              <p>{{ chapter.description }}</p>
              <div class="chapter-date">{{ chapter.publication_date }}</div>
              <v-row clas="align-center mt-2 chapter-info" dense>
                <v-col cols="auto" class="d-flex align-center chapter-icon-text">
                  <v-icon small color="#fff">mdi-message</v-icon>
                  {{ chapter.comments || 0 }}
                </v-col>
                <v-col cols="auto" class="d-flex align-center chapter-icon-text">
                  <v-icon small color="#fff">mdi-eye</v-icon>
                  {{ chapter.views || 0 }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-card-text>
          <v-btn @click="closeMenuModal" color="error" block>Fechar</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>


</template>

<script>
import { openSafeHttpUrl } from '@/utils/safeNavigation';
import { getProjectDetailsById } from '@/server/homeServe';
import { LikeTitleService } from '@/server/LikeService';
import { getReadingPath } from '@/utils/projectCategory';

export default {
  name: 'WidgetReadMenu',
  data: () => {
    return {
      menuModalOpen: false,
      chapters: [],
    }
  },
  props: {
    next_chapter: {
      type: [String, Number, null],
      default: null
    },
    previous_title: {
      type: [String, Number, null],
      default: null
    },
    idObra: {
      type: [String, Number],
      required: true
    },
    idChapter: {
      type: [String, Number],
      required: true
    },
    chapter: {
      type: Object,
      default: () => ({
        is_like: false,
        likes_count: 0
      })
    },
    project: {
      type: Object,
      default: null
    }
  },
  methods: {
    async openMenuModal() {
      this.menuModalOpen = true;
      const data = await this.fetchObra();
      this.chapters = data.titles;
    },
    closeMenuModal() {
      this.menuModalOpen = false;
    },
    shareOnWhatApp() {
      const pageUrl = encodeURIComponent(window.location.href);
      const message = encodeURIComponent('Confira este link: ')
      const whatsappUrl = `https://wa.me/?text=${message}${pageUrl}`;

      openSafeHttpUrl(whatsappUrl);
    },

    async toggleLikeChapter() {
      try {
        const service = new LikeTitleService();
        await service.store({ title_id: this.idChapter });
        this.$emit('update-chapter');
      } catch (error) {
        console.error('Erro ao curtir capítulo:', error);
      }
    },

    readingPath(chapterId) {
      return getReadingPath(this.project || this.chapter, chapterId);
    },

    nextChapter() {
      const path = this.readingPath(this.next_chapter);
      if (!path) return;

      this.$router.push(path);
      this.$emit('update-chapter');
    },

    backChapter() {
      const path = this.readingPath(this.previous_title);
      if (!path) return;

      this.$router.push(path);
      this.$emit('update-chapter');
    },

    async fetchObra() {
      try {
        const data = await getProjectDetailsById(this.idObra);
        this.obra = data.project;
        this.author = data.author;
        this.chapters = data.titles;
        this.similar_projects = data.similar_projects;
        this.author_projects = data.author_projects;
      } catch (error) {
        console.error('Erro ao buscar obra:', error);
      }
    },
    goToReadingPage(idChapter) {
      const path = this.readingPath(idChapter);
      if (!path) return;

      this.$router.push(path);
      this.closeMenuModal();
    },
  }
}
</script>


<style scoped>
p {
  color: #fff !important;
}
.outer-div {
  position: fixed;
  bottom: 50px;
  right: 30px;
  border: 2px solid #000;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 30px;
  align-self: self-end;
}

.btn-heart {
  background-color: transparent !important;
  border: 2px solid white !important;
  border-radius: 16px !important;
  width: 52px !important;
  height: 52px !important;
  transition: all 0.3s ease;
}

.btn-heart:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
  transform: scale(1.05);
}

.btn-heart:disabled {
  border-color: rgba(255, 255, 255, 0.3) !important;
  opacity: 0.5;
}

.card-obra {
  width: 100% !important;
}
</style>
